export default {
	functional: true,
	props: {
		isForm: {
			type: Boolean,
			default: false,
		},
	},

	render(h, ctx) {
		const { props, data } = ctx;
		const { attrs } = data;

		return h(
			props.isForm ? 'form' : 'div',
			{
				...data,
				class: 'modal-content',
			},
			ctx.children
		);
	},
};
